"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const difference_1 = tslib_1.__importDefault(require("lodash/difference"));
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const fieldsToExclude = [
    'createdAt',
    'updatedAt',
    'lastUpdatedTimeSpent',
    'lastSubmittedOn',
    'startedOn',
    'lastAccessedOn',
    'successOn',
    'completedOn'
];
function areDocsEqual(doc1, doc2) {
    return doc1 === doc2;
}
exports.default = areDocsEqual;
function areDocsEqualDeep(oldDoc, newDoc) {
    const keysToCompareOfOldDocDic = keyBy_1.default(difference_1.default(Object.keys(oldDoc), fieldsToExclude));
    const keysToCompareOfNewDoc = difference_1.default(Object.keys(newDoc), fieldsToExclude);
    let keyNotPresentInOldDoc = false;
    let valuesUnEqualInOldDoc = false;
    keysToCompareOfNewDoc.forEach((key) => {
        if (!keysToCompareOfOldDocDic[key]) {
            keyNotPresentInOldDoc = true;
        }
        else {
            if (oldDoc[key] !== newDoc[key]) {
                valuesUnEqualInOldDoc = true;
            }
        }
    });
    return !keyNotPresentInOldDoc || !valuesUnEqualInOldDoc;
}
exports.areDocsEqualDeep = areDocsEqualDeep;
//# sourceMappingURL=areDocsEqual.js.map